export const MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;
export const INT32_MAX = 2147483647;

export const DEFAULT_ALLOWED_UPLOAD_MIME_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/gif",
  "image/bmp",
  "image/webp",
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
];

export const DEFAULT_ALLOWED_UPLOAD_ACCEPT =
  ".jpg,.jpeg,.png,.gif,.bmp,.webp,.pdf,.doc,.docx,.ppt,.pptx";

export function normalizePan(value) {
  return (value || "").toString().trim().toUpperCase();
}

export function isValidPan(value) {
  const v = normalizePan(value);
  if (!v) return false;
  return /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(v);
}

export function validateInt32(label, rawValue) {
  if (rawValue === "" || rawValue === null || rawValue === undefined) return null;
  const num = Number(rawValue);
  if (!Number.isFinite(num)) return `${label} must be a valid number`;
  if (num < 0) return `${label} cannot be negative`;
  if (num > INT32_MAX) return `${label} is too large (max ${INT32_MAX})`;
  return null;
}

export function validateUploadFile(file, options = {}) {
  if (!file) return { ok: false, error: "No file selected" };

  const {
    allowedMimeTypes = DEFAULT_ALLOWED_UPLOAD_MIME_TYPES,
    maxBytes = MAX_FILE_SIZE_BYTES,
    allowEmptyMimeType = true,
  } = options;

  if (file.size > maxBytes) {
    return { ok: false, error: `File size should not exceed ${Math.floor(maxBytes / 1024 / 1024)}MB` };
  }

  if (!file.type) {
    if (allowEmptyMimeType) {
      return { ok: true };
    }
    return { ok: false, error: "File type could not be determined" };
  }

  if (!allowedMimeTypes.includes(file.type)) {
    return {
      ok: false,
      error: "Only image files (JPG, PNG, GIF, BMP, WebP) and PDF/DOC/PPT files are allowed",
    };
  }

  return { ok: true };
}
